import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Box from '@mui/material/Box';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

import { Baseurl
 } from "../lib/url";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,

    "& .MuiTextField-root": {
      margin: 10,
      width: "300px"
    },
    "& .MuiButtonBase-root": {
      margin: 15
    }
  }
}));

const RegisterView = props => {
  const classes = useStyles();
  // create state variables for each input
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const {open} = props;
  const {setViewRegisterOpen} = props;
  const {response, setResponse} = useState();
  const handleSubmit = (e) => {
    //e.preventDefault();
    console.log(firstName, lastName, email, password);
      // Simple POST request with a JSON body using fetch
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: firstName + ' ' + lastName, password: password, email: email, username: email })
      };
      fetch(`${Baseurl}/register`, requestOptions)
          .then(response => response.json())
          .then(data => setToken(data))
          .then(() => setViewRegisterOpen(false));
      

    //;
    function setToken(userToken) {
      sessionStorage.setItem('token', JSON.stringify(userToken));
    }
     
};

  

  return (
    <Dialog
    onClose={() => setViewRegisterOpen(false)}
    aria-labelledby="settings-dialog-title"
    open={open}
  >
            <DialogTitle id="settings-dialog-title"  className="dialogTitle">
      Register
      <IconButton>
          <CloseIcon style={{ color: "#ff334b" }}/>
        </IconButton>
    </DialogTitle>
    <Box           component="form"
>
    <form className={classes.root} onSubmit={handleSubmit}>
      <TextField
        autoFocus
        label="First Name"
        required
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />
      <TextField
        label="Last Name"
        required
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />
      <TextField
        label="Email"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label="Password"
        type="password"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <TextField
        label="Confirm Password"
        type="password"
        required
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <div>
        <Button  onClick={() => setViewRegisterOpen(false)}>
          Cancel
        </Button>
        <Button type="submit" color="primary" onClick={() => handleSubmit()}>
          Signup
        </Button>
      </div>
    </form>
    </Box>
    </Dialog>
  );
};

export default RegisterView;
